import { TypedUseSelectorHook, useDispatch, useSelector, shallowEqual } from 'react-redux';
import type { RootState, AppDispatch } from '../index';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

/**
 * Custom selector hook that caches results by default
 * and only triggers re-renders when the selected state changes
 */
export function useTypedSelector<TSelected>(selector: (state: RootState) => TSelected) {
  return useAppSelector(selector, shallowEqual);
}
